export const metaDescriptions = (description) => [
  { vmid: 'description', name: 'description', content: description },
  { vmid: 'twitter:description', name: 'twitter:description', content: description },
  { vmid: 'og:description', property: 'og:description', content: description },
];

export const metaTitles = (title) => [
  {
    vmid: 'twitter:title',
    name: 'twitter:title',
    content: `${title} | mathiasmoeller.com | Nature & Travel Photography`,
  },
  {
    vmid: 'og:title',
    property: 'og:title',
    content: `${title} | mathiasmoeller.com | Nature & Travel Photography`,
  },
];

export const metaImage = (image, width = 640, height = 480) => {
  // eslint-disable-next-line max-len
  const imageUrl = `https://${window.location.hostname}${image}`;
  return [
    {
      vmid: 'thumbnail',
      name: 'thumbnail',
      content: imageUrl,
    },
    {
      vmid: 'og:image:url',
      property: 'og:image:url',
      content: imageUrl,
    },
    {
      vmid: 'og:image:secure_url',
      property: 'og:image:secure_url',
      content: imageUrl,
    },
    {
      vmid: 'og:image:width',
      property: 'og:image:width',
      content: width,
    },
    {
      vmid: 'og:image:height',
      property: 'og:image:height',
      content: height,
    },
  ];
};

export const metaGeneral = () => [
  {
    vmid: 'og:url',
    property: 'og:url',
    content: window.location.href,
  },
  {
    vmid: 'og:type',
    property: 'og:type',
    content: 'website',
  },
  {
    vmid: 'article:author',
    name: 'article:author',
    content: 'Mathias Möller',
  },
];
